import { useRef } from "react";
import { GridRowsProp } from "@mui/x-data-grid-premium";
import { columns } from "./columns";
import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { NestedSubtableDetailPanel } from "../../../components/datagrid/DetailPanels/NestedSubtable";
import { renderDate } from "../../../formatting/dateFormat";

export function OrdersTablePage() {
  // Create stable cache reference for nested order history data
  const ordersNestedCache = useRef(
    new Map<string, { rows: GridRowsProp; totalCount: number }>()
  );

  return (
    <ServerDataGrid
      columns={columns}
      apiEndpoint="/datagrid/orders"
      getRowId={(row) => {
        return row.amazon_listings.msku;
      }}
      height={"calc(100vh - 52.6px)"}
      tableName="orders"
      getDetailPanelContent={(params, apiRef) => (
        <NestedSubtableDetailPanel
          params={params}
          apiEndpoint="/datagrid/orders"
          nestedRelationName="amazon_order_history"
          getRowId={(row) => row.amazon_order_history?.order_id}
          parentApiRef={apiRef}
          cache={ordersNestedCache.current}
          initialStateOverride={{
            sorting: {
              sortModel: [
                {
                  field: "amazon_order_history.order_timestamp",
                  sort: "desc",
                },
              ],
            },
          }}
          columns={[
            {
              headerName: "Order ID",
              field: "amazon_order_history.order_id",
              valueGetter: (value, row) => row.amazon_order_history?.order_id,
              width: 250,
            },

            {
              headerName: "Order Timestamp",
              field: "amazon_order_history.order_timestamp",
              valueGetter: (value, row) =>
                row.amazon_order_history?.order_timestamp,
              valueFormatter: (value) => renderDate(value),
              width: 300,
            },
            {
              headerName: "Order Quantity",
              field: "amazon_order_history.order_qty",
              valueGetter: (value, row) => row.amazon_order_history?.order_qty,
              width: 150,
            },
            {
              headerName: "Order Status",
              field: "amazon_order_history.order_status",
              valueGetter: (value, row) =>
                row.amazon_order_history?.order_status,
              width: 150,
            },
            {
              headerName: "Order Country",
              field: "amazon_order_history.order_country",
              valueGetter: (value, row) =>
                row.amazon_order_history?.order_country,
              width: 150,
            },
            {
              headerName: "Order Price",
              field: "amazon_order_history.order_price",
              valueGetter: (value, row) =>
                row.amazon_order_history?.order_price,
              width: 150,
            },
            {
              headerName: "Order Profit",
              field: "amazon_order_history.order_profit",
              valueGetter: (value, row) =>
                row.amazon_order_history?.order_profit,
              width: 150,
            },
            {
              headerName: "Order COGS Value",
              field: "amazon_order_history.cogs_value",
              valueGetter: (value, row) => row.amazon_order_history?.cogs_value,
              width: 150,
            },
            {
              headerName: "Order COGS Type",
              field: "amazon_order_history.cogs_type",
              valueGetter: (value, row) => row.amazon_order_history?.cogs_type,
              width: 150,
            },
            {
              headerName: "Order Proceeds",
              field: "amazon_order_history.order_proceeds",
              valueGetter: (value, row) =>
                row.amazon_order_history?.order_proceeds,
              width: 150,
            },
          ]}
        />
      )}
    />
  );
}
